import { axiosApiClient } from "..";

const ordersService = {
  // Create a new order
  createOrder: async (orderData) => {
    try {
      const response = await axiosApiClient.post("/orders", orderData);
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          message: "Greška prilikom kreiranja porudžbine",
        }
      );
    }
  },

  // Get user's orders (requires authentication)
  getUserOrders: async () => {
    try {
      const response = await axiosApiClient.get("/orders");
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          message: "Greška prilikom dohvatanja porudžbina",
        }
      );
    }
  },

  // Get order by ID (requires authentication)
  getOrderById: async (orderId) => {
    try {
      const response = await axiosApiClient.get(`/orders/${orderId}`);
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          message: "Greška prilikom dohvatanja porudžbine",
        }
      );
    }
  },
  // Get order by ID (requires authentication)
  exportOrders: async (filters) => {
    try {
      const params = new URLSearchParams({
        search: filters.search || "",
        dateFrom: filters.dateFrom || "",
        dateTo: filters.dateTo || "",
      });

      const response = await axiosApiClient.get(`/orders/export?${params}`);
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          message: "Greška prilikom dohvatanja porudžbine",
        }
      );
    }
  },
};

export default ordersService;
